// Animation intersection observer setup
const stickyBar = document.querySelector('.j-sticky-bar');

const callback = (entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			stickyBar.classList.add('hidden');
		} else {
			stickyBar.classList.remove('hidden');
		}
	})
}

let threshold = window.innerWidth < 640 ? 0.2 : 0.4;

const myObserver = new IntersectionObserver(callback, { 
	threshold
});

function addToObserver() {
	document.querySelectorAll('#vue-product-details').forEach(elem => {
		myObserver.observe(elem);
	})
}

addToObserver();